module.exports = __webpack_public_path__ + "static/gasshuku2024-19d4e06064f95d8fd64707a2b013c502.webp";